import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { GambleFlowManager } from '@dragonframework/modules'

export class GambleState extends BaseState {
    public begin() {
        if (!GambleFlowManager.isActive()) {
            this.end()
            return
        }

        GameSignals.showGambleButton.emit()
        GameSignals.spinButtonClicked.connect(this.onSpinButtonClicked)
        ;(GameSignals as any).gambleFlowStateChanged?.connect(this.onGambleFlowStateChanged)
    }

    public end = () => {
        GameSignals.hideGambleButton.emit()
        GameSignals.spinButtonClicked.disconnect(this.onSpinButtonClicked)
        this._stateMachine.setState(GameStatesEnum.IDLE_STATE)
    }

    public cleanUp() {
        GameSignals.hideGambleButton.emit()
        GameSignals.spinButtonClicked.disconnect(this.onSpinButtonClicked)
        ;(GameSignals as any).gambleFlowStateChanged?.disconnect(this.onGambleFlowStateChanged)
    }

    private onSpinButtonClicked = () => {
        ;(GameSignals as any).requestGambleCollect?.emit()
    }

    private onGambleFlowStateChanged = () => {
        if (!GambleFlowManager.isActive()) {
            this.end()
        }
    }
}